import List from './list';
import Menu from '../models/menu';
import { excuseApi } from '../commons/http';

export default class Menus extends List {
  async fetch(params = {}) {
    const queryParams = new URLSearchParams({
      per_page: params.per_page || 10,
      page: params.page || 1,
      ...(params.status && { status: params.status }),
      ...(params.user_id && { user_id: params.user_id }),
      ...(params.user_package_id && { user_package_id: params.user_package_id }),
      ...(params.search && { search: params.search }),
    }).toString();

    const res = await excuseApi({
      path: `/menus?${queryParams}`,
      method: 'GET',
    });

    if (res.status === 200) {
      this.mapData(res.data.data);
      return {
        total: res.data.total,
        page: res.data.page,
        per_page: res.data.per_page,
      };
    }
    return null;
  }

  mapData(data = []) {
    for (const item of data) {
      const menu = new Menu();
      menu.mapData(item);
      this.add(menu);
    }
  }
}
